"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckboxStyle = void 0;
exports.default = Checkbox;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
const CheckboxStyle = theme => ({
  padding: theme.spacing(0, 1, 0, 0),
  '& .MuiSvgIcon-root': {
    fill: theme.palette.TwClrBrdrSecondary
  },
  '&:hover > .MuiSvgIcon-root': {
    fill: theme.palette.TwClrBrdrHover
  },
  '&.Mui-checked > .MuiSvgIcon-root': {
    fill: theme.palette.TwClrBgSelected,
    color: theme.palette.TwClrBgSelected
  },
  '&.MuiCheckbox-indeterminate > .MuiSvgIcon-root': {
    fill: theme.palette.TwClrBgSelected,
    color: theme.palette.TwClrBgSelected
  },
  '&:focus > .MuiSvgIcon-root': {
    border: "2px solid ".concat(theme.palette.TwClrBgSelected)
  },
  '&.Mui-disabled': {
    opacity: 0.5
  }
});
exports.CheckboxStyle = CheckboxStyle;
function Checkbox(props) {
  var _props$value;
  const theme = (0, _material.useTheme)();
  const onChange = (event, checked) => {
    props.onChange(checked);
  };
  return /*#__PURE__*/_react.default.createElement(_material.FormControlLabel, {
    id: props.id,
    onChange: onChange,
    label: props.label,
    disabled: props.disabled,
    control: /*#__PURE__*/_react.default.createElement(_material.Checkbox, {
      disabled: props.disabled,
      disableRipple: true,
      id: 'check-' + props.id,
      checked: (_props$value = props.value) !== null && _props$value !== void 0 ? _props$value : false,
      size: "medium",
      sx: CheckboxStyle(theme)
    }),
    className: props.className,
    sx: {
      alignItems: 'flex-start',
      color: theme.palette.TwClrTxt,
      fontFamily: 'Inter',
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '24px',
      margin: theme.spacing(1, 0, 0, 0)
    }
  });
}